module.exports = __webpack_public_path__ + "img/shareTip.168ebf15.png";